import React, { FC } from 'react';
import { graphql } from 'gatsby';

import LegalPage, { ILegalPageProps } from 'components/LegalPage';

const DisclaimerPage: FC<ILegalPageProps> = ({
  data,
}) => (
  <LegalPage data={data} />
);

export const query = graphql`
  query DisclaimerPageQuery {
    legalPageData: allContentfulLegalPage(
      filter: { slug: {eq: "disclaimer" } }
    ) {
       nodes {
         slug
         title
         body {
           raw
         }
       }
    }
  }
`;

export default DisclaimerPage;
